function initWizzyHeaderSearchRouting() {
  if (initWizzyHeaderSearchRouting._bound) return;
  initWizzyHeaderSearchRouting._bound = true;

  function getDesktopSearchBox() {
    return document.querySelector("#site-header .st-search-box.hidden-mobile");
  }

  function isDesktopSearchBarOpen() {
    var searchBox = getDesktopSearchBox();
    if (!searchBox) return false;
    return window.getComputedStyle(searchBox).display !== "none";
  }

  function getPinnedHeaderContainerEl() {
    var sticky = document.querySelector(".sticky-header.show");
    if (sticky) {
      return (
        sticky.querySelector(
          ".header__bottom.header-container.container--large",
        ) ||
        sticky.querySelector(".header__bottom.container--large") ||
        sticky.querySelector(".header__bottom")
      );
    }
    return (
      document.querySelector("#site-header .header__bottom.container--large") ||
      document.querySelector("#site-header .header__bottom")
    );
  }

  function getVisibleHeaderRowEl() {
    return getPinnedHeaderContainerEl() || document.getElementById("site-header");
  }

  function clampSearchLeftInContainer(left, width, containerRect) {
    if (!containerRect) {
      var maxViewport = window.innerWidth - width - 8;
      if (maxViewport < 0) maxViewport = 0;
      if (left > maxViewport) left = maxViewport;
      if (left < 0) left = 0;
      return left;
    }
    var minLeft = Math.round(containerRect.left);
    var maxLeft = Math.round(containerRect.right - width);
    if (maxLeft < minLeft) maxLeft = minLeft;
    if (left < minLeft) left = minLeft;
    if (left > maxLeft) left = maxLeft;
    return left;
  }

  function getSearchPinAnchorRect() {
    var sticky = document.querySelector(".sticky-header.show");
    if (sticky) {
      var stickyIcon = sticky.querySelector(".st-search-icon.search-icon");
      if (stickyIcon) {
        var iconRow = stickyIcon.parentElement;
        if (
          iconRow &&
          iconRow !== sticky &&
          (iconRow.getBoundingClientRect().width ||
            iconRow.getBoundingClientRect().height)
        ) {
          return iconRow.getBoundingClientRect();
        }
        return stickyIcon.getBoundingClientRect();
      }
    }
    var centeredIcons = document.querySelector(
      "#site-header .centered-menu-right-icons",
    );
    if (
      centeredIcons &&
      window.getComputedStyle(centeredIcons).display !== "none"
    ) {
      return centeredIcons.getBoundingClientRect();
    }
    var icon = document.querySelector(
      "#site-header .header-container--bottom .st-search-icon.search-icon",
    );
    return icon ? icon.getBoundingClientRect() : null;
  }

  function getPinnedSearchHorizontalStyles(searchBox) {
    var width =
      searchBox.getBoundingClientRect().width ||
      searchBox.offsetWidth ||
      320;
    var container = getPinnedHeaderContainerEl();
    var containerRect = container ? container.getBoundingClientRect() : null;
    var anchorRect = getSearchPinAnchorRect();
    var left;

    if (anchorRect && (anchorRect.width || anchorRect.height)) {
      left = Math.round(anchorRect.right - width);
    } else if (containerRect) {
      left = Math.round(containerRect.right - width);
    } else {
      left = Math.round(window.innerWidth - width - 8);
    }

    left = clampSearchLeftInContainer(left, width, containerRect);

    return { left: left + "px", right: "auto" };
  }

  /** Pin when sticky is shown or the main header row has scrolled up. */
  function shouldPinSearchBelowHeader() {
    if (document.querySelector(".sticky-header.show")) return true;
    var headerRow = document.querySelector("#site-header .header__bottom");
    if (headerRow && headerRow.getBoundingClientRect().top < 0) return true;
    return false;
  }

  function getHeaderBottomForSearch() {
    var row = getVisibleHeaderRowEl();
    if (!row) return 0;
    return Math.round(row.getBoundingClientRect().bottom);
  }

  function isElementIntersectingViewport(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    if (!rect.width && !rect.height) return false;
    if (rect.bottom <= 0 || rect.top >= window.innerHeight) return false;
    if (rect.right <= 0 || rect.left >= window.innerWidth) return false;
    return true;
  }

  /** Autocomplete may show only when desktop search bar and header row are on screen. */
  function isDesktopSearchAndHeaderVisible() {
    if (!isDesktopSearchBarOpen()) return false;
    if (!isElementIntersectingViewport(getDesktopSearchBox())) return false;
    if (!isElementIntersectingViewport(getVisibleHeaderRowEl())) return false;
    return true;
  }

  function syncDesktopAutocompleteDisplay() {
    if (window.matchMedia("(max-width: 768px)").matches) return;
    var autoComplete = document.querySelector(".wizzy-autocomplete-wrapper");
    if (!autoComplete) return;

    if (isDesktopSearchAndHeaderVisible()) {
      autoComplete.style.removeProperty("display");
      autoComplete.removeAttribute("data-wizzy-sync-hidden");
      return;
    }

    autoComplete.style.setProperty("display", "none", "important");
    autoComplete.setAttribute("data-wizzy-sync-hidden", "true");
  }

  window.syncDesktopAutocompleteDisplay = syncDesktopAutocompleteDisplay;

  function resetDesktopSearchBoxPinStyles() {
    var searchBox = getDesktopSearchBox();
    if (!searchBox) return;
    searchBox.style.removeProperty("position");
    searchBox.style.removeProperty("top");
    searchBox.style.removeProperty("right");
    searchBox.style.removeProperty("left");
    searchBox.style.removeProperty("transform");
    searchBox.style.removeProperty("z-index");
    searchBox.style.removeProperty("padding");
    searchBox.removeAttribute("data-wizzy-search-pinned");
  }

  function applyPinnedSearchBoxBelowHeader() {
    if (window.matchMedia("(max-width: 768px)").matches) return;
    var searchBox = getDesktopSearchBox();
    if (!searchBox || !isDesktopSearchBarOpen()) {
      resetDesktopSearchBoxPinStyles();
      syncDesktopAutocompleteDisplay();
      return;
    }
    if (!shouldPinSearchBelowHeader()) {
      resetDesktopSearchBoxPinStyles();
      syncDesktopAutocompleteDisplay();
      return;
    }

    var topPx = getHeaderBottomForSearch();
    if (topPx <= 0) {
      resetDesktopSearchBoxPinStyles();
      syncDesktopAutocompleteDisplay();
      return;
    }

    var horizontal = getPinnedSearchHorizontalStyles(searchBox);
    searchBox.style.setProperty("position", "fixed", "important");
    searchBox.style.setProperty("top", topPx + "px", "important");
    searchBox.style.setProperty("left", horizontal.left, "important");
    searchBox.style.setProperty("right", horizontal.right, "important");
    searchBox.style.setProperty("transform", "none", "important");
    searchBox.style.setProperty("z-index", "99999999", "important");
    searchBox.style.setProperty("padding", "0", "important");
    searchBox.setAttribute("data-wizzy-search-pinned", "true");
    syncDesktopAutocompleteDisplay();
  }

  function openWizzySearch() {
    if (window.matchMedia("(max-width: 768px)").matches) {
      document.body.classList.add("wizzyMobileTapped");
      var wrapper = document.querySelector(".wizzy-search-form-wrapper");
      if (wrapper) wrapper.classList.add("mobileTapped");
      var mobileInput = document.querySelector("#search_mini_form #searchInput");
      if (mobileInput) mobileInput.click();
      return;
    }
    if (typeof toggleStSearchBar === "function") toggleStSearchBar(true);
    applyPinnedSearchBoxBelowHeader();
    syncDesktopAutocompleteDisplay();
    var desktopInput = document.querySelector(
      "#site-header .st-search-box.hidden-mobile .st-search-input",
    );
    if (desktopInput) {
      setTimeout(function () {
        applyPinnedSearchBoxBelowHeader();
        syncDesktopAutocompleteDisplay();
        desktopInput.click();
      }, 300);
    }
  }

  function handleDesktopSearchScrollOrResize() {
    applyPinnedSearchBoxBelowHeader();
    syncDesktopAutocompleteDisplay();
  }

  window.addEventListener("scroll", handleDesktopSearchScrollOrResize, {
    passive: true,
  });
  window.addEventListener("resize", handleDesktopSearchScrollOrResize, {
    passive: true,
  });

  document.addEventListener(
    "click",
    function (e) {
      var isMobile = window.matchMedia("(max-width: 768px)").matches;
      var closeBtn = e.target.closest(".st-search-close-btn");
      var inlineClose = e.target.closest(
        "#site-header .st-search-box.hidden-mobile .wz-autocomplete-cross-icon",
      );
      if ((closeBtn || inlineClose) && !isMobile) {
        resetDesktopSearchBoxPinStyles();
        syncDesktopAutocompleteDisplay();
        return;
      }

      var trigger = e.target.closest(
        ".area--search, .st-search-icon.st-autocomplete-open-btn, .st-search-icon.search-icon",
      );
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openWizzySearch();
    },
    true,
  );

  /*
   * When sticky / scrolled header: pin .st-search-box with fixed layout; top = header bottom (JS).
   * Other pin styles match SearchTap desktop box (right + transform); theme absolute CSS when unpinned.
   */
}

try {
  initWizzyHeaderSearchRouting();

  const clearInputButton = window.innerWidth > 768 ? document.querySelector(".st-search-box.hidden-mobile svg.wz-autocomplete-cross-icon") : document.querySelector(".wizzy-search-form-wrapper svg.wz-autocomplete-cross-icon")
  const searchInput = window.innerWidth > 768 ? document.querySelector(".st-search-box.hidden-mobile .st-search-input") : document.querySelector("#searchInput");
  if(clearInputButton && searchInput) {
    clearInputButton.addEventListener("click", function() {
        searchInput.value = "";
        setTimeout(()=>{
          searchInput.click();
        })
    });
  }
  
  (function patchProductVariantsGetVariantDataForWizzy() {
    if (typeof customElements === "undefined") return;
    const Ctor = customElements.get("product-variants");
    if (!Ctor || Ctor.prototype._wizzyVariantJsonPatch) return;

    Ctor.prototype._wizzyVariantJsonPatch = true;
    Ctor.prototype.getVariantData = function () {
      if (this.variantData) {
        return this.variantData;
      }
      const script = this.querySelector('[type="application/json"]');
      if (!script || !String(script.textContent || "").trim()) {
        this.variantData = [];
        return this.variantData;
      }

      try {
        this.variantData = JSON.parse(script.textContent);
        return this.variantData;
      } catch (e) {
        this.variantData = [];
        return this.variantData;
      }
    };
  })();

  function checkWizzyConfigAndUpdate() {
    window.wizzyConfig &&
      (window.matchMedia("(max-width: 768px)").matches
        ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "#search_mini_form #searchInput",
          type: "search",
        })
        : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: "#site-header .st-search-box.hidden-mobile .st-search-input",
          type: "text",
        }));
    clearInterval(interval);
  }
  var interval = setInterval(checkWizzyConfigAndUpdate, 100);

  //handle searchbar for moblie and desktop
  const searchInputBar =
    window.innerWidth < 768
      ? document.querySelector("#search_mini_form #searchInput")
      : document.querySelector("#site-header .st-search-box.hidden-mobile .st-search-input");
  const searchIcon =
    window.innerWidth < 768
      ? document.querySelector("#site-header .site-nav__link.search-icon")
      : document.querySelectorAll(
        ".header-container--bottom .st-search-icon.search-icon",
      );

  if (window.innerWidth < 768) {
    if (searchIcon && searchInputBar) {
      searchIcon.addEventListener("click", () => {
        searchInputBar.click();
      });
    }
  } else {
    searchIcon.forEach((a) => {
      a.addEventListener("click", (e) => {
        setTimeout(() => {
          toggleStSearchBar(true);
          searchInputBar?.click();
        }, 300);
      });
    });
  }

  function createViewMoreBtn(
    itemsToShowCount,
    element,
    facetItems,
    viewMoreBtn,
  ) {
    const initialItemsToShow = itemsToShowCount;
    let itemsToShow = initialItemsToShow;
    let isExpanded = false;

    viewMoreBtn.style.display = "flex";
    viewMoreBtn.textContent = "Show More";

    const updateVisibility = () => {
      facetItems.forEach((item, index) => {
        if (index < itemsToShow) {
          item.classList.remove("visible");
        } else {
          item.classList.add("visible");
        }
      });
    };
    // Initial state
    updateVisibility();

    viewMoreBtn.addEventListener("click", () => {
      if (!isExpanded) {
        // VIEW MORE
        itemsToShow = facetItems.length;
        viewMoreBtn.textContent = "Show Less";
        isExpanded = true;
      } else {
        // VIEW LESS
        itemsToShow = initialItemsToShow;
        viewMoreBtn.textContent = "Show More";
        isExpanded = false;
      }
      updateVisibility();
    });
  }

  function OpenFilters() {
    let searchWrapper = document.querySelector(
      ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results ",
    );
    let filterWrapper = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-filters-left-wrapper",
    );
    let wizzySearchFiltersLeft = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-results-wrapper .wizzy-search-filters-left",
    );
    let navBar = document.querySelector(".wizzy-search-results");
    if (searchWrapper) searchWrapper.classList.add("filter-opened");
    if (filterWrapper) filterWrapper.classList.add("opened");
    if (wizzySearchFiltersLeft) wizzySearchFiltersLeft.classList.add("opened");
    let textFilter = document.querySelector(".wizzy-filters-button-text");
    if (textFilter) textFilter.innerText = "Hide Filter";
  }

  function CloseFilters() {
    let filterWrapper = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-filters-left-wrapper",
    );
    let searchWrapper = document.querySelector(
      ".wizzy-search-wrapper.has-left-facets .wizzy-search-results-wrapper .wizzy-search-results-container .wizzy-search-results ",
    );
    let wizzySearchFiltersLeft = document.querySelector(
      ".has-facets-in-drawer .wizzy-search-results-wrapper .wizzy-search-filters-left",
    );
    if (searchWrapper) searchWrapper.classList.remove("filter-opened");
    if (filterWrapper) filterWrapper.classList.remove("opened");
    if (wizzySearchFiltersLeft)
      wizzySearchFiltersLeft.classList.remove("opened");

    let textFilter = document.querySelector(".wizzy-filters-button-text");
    if (textFilter) textFilter.innerText = "Show Filter";
  }

  function handleFilterClick(e) {
    e.preventDefault();
    let filter_open = localStorage.getItem("filter_opened") || 1;

    if (filter_open == 0) {
      OpenFilters();
      localStorage.setItem("filter_opened", 1);
    } else {
      CloseFilters();
      localStorage.setItem("filter_opened", 0);
    }
  }

  function generateStars(ratingInput) {
    const rating = parseFloat(ratingInput);
    const totalStars = 5;

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0 ? 1 : 0;
    const emptyStars = totalStars - fullStars - hasHalfStar;

    let starsHTML = "";

    const fullSVG = `
    <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-full" width="14" height="14" style="margin-inline-end: 3.5px;">
	    <defs>
		    <linearGradient id="yotpo_stars_gradient_0.43704383472885777">
		        <stop offset="100%" stop-color="rgba(0,0,0,1)"></stop>
		        <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
			  </linearGradient>
		  </defs>
		  <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(0,0,0,1)" fill="url('#yotpo_stars_gradient_0.43704383472885777')"></path>
	</svg>`;

    const halfSVG = `
    <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-half" width="14" height="14" style="margin-inline-end: 3.5px;">
	    <defs>
		    <linearGradient id="yotpo_stars_gradient_0.4329749053409041">
          <stop offset="51%" stop-color="rgba(0,0,0,1)"></stop>
          <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
			  </linearGradient>
		  </defs>
		  <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(0,0,0,1)" fill="url('#yotpo_stars_gradient_0.4329749053409041')"></path>
	</svg>`;

    const emptySVG = `
    <svg aria-hidden="true" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="star-container yotpo-sr-star-empty" width="14" height="14" style="margin-inline-end: 3.5px;">
      <defs>
		    <linearGradient id="yotpo_stars_gradient_0.5132721571541169">
		        <stop offset="0%" stop-color="rgba(0,0,0,1)"></stop>
		        <stop stop-opacity="1" offset="0%" stop-color="#FFFFFF"></stop>
			  </linearGradient>
		  </defs>
		  <path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="rgba(0,0,0,1)" fill="url('#yotpo_stars_gradient_0.5132721571541169')"></path>
	</svg>`;

    for (let i = 0; i < fullStars; i++) starsHTML += fullSVG;
    if (hasHalfStar) starsHTML += halfSVG;
    for (let i = 0; i < emptyStars; i++) starsHTML += emptySVG;

    return starsHTML;
  }

  function changeTemplate(div) {
    const oldDiv = document.getElementById(div);
    newDiv = document.getElementById(div + "-new").text;
    oldDiv.text = newDiv;
  }

  function handleScrollOnSearchPage() {
    var width_btn = document.querySelector(
      ".wizzy-search-sort-wrapper",
    ).clientWidth;
    document.addEventListener("scroll", function () {
      var element = document.querySelector(".search-filters-top-wrapper");
      if (element) {
        var rect = element.getBoundingClientRect();
        if (rect.top < 0) {
          document
            .querySelectorAll(".search-heading__actions")
            .forEach((jj) => {
              jj.classList.add("sticky-filter");
            });
          if (document.querySelector(".sticky-header.show")) {
            var header_height = document.querySelector(
              ".sticky-header.show",
            ).clientHeight;
            document
              .querySelectorAll(".search-heading__actions")
              .forEach((jj) => {
                jj.style.top = header_height + "px";
                // jj.style.width = width_btn + 'px';
              });
          } else {
            document
              .querySelectorAll(".search-heading__actions")
              .forEach((jj) => {
                jj.style.top = 0;
                // jj.style.width = width_btn + 'px';
              });
          }
        } else {
          document
            .querySelectorAll(".search-heading__actions")
            .forEach((jj) => {
              jj.classList.remove("sticky-filter");
              // jj.style.width = 48+'%';
              jj.style.top = 0;
            });
        }
      } else {
        console.log("Element not found");
      }
    });
  }

  function transformToVariants(product) {
    const result = [];

    const {
      name,
      mainImage,
      images,
      attributes,
      swatches,
      id: productId,
      groupId,
    } = product;

    const attrMap = {};
    attributes?.forEach((attr) => {
      const map = {};
      attr.values?.forEach((v) => {
        map[v.variationId] = v.value?.[0];
      });
      attrMap[attr.id] = map;
    });

    const variants = swatches?.[0]?.values || [];

    if (variants.length) {
      variants.forEach((variant, index) => {
        const variationId = variant.variationId;
        const price = attrMap["product_variant_prices"]?.[variationId];
        const comparePrice =
          attrMap["product_variant_compare_at_prices"]?.[variationId];
        const sku = attrMap["product_sku"]?.[variationId];
        const barcode = attrMap["product_barcode"]?.[variationId];
        const size = attrMap["product_Size"]?.[variationId] || variant.value;
        const image = images?.[index] || mainImage;

        result.push({
          id: variationId,
          title: size,
          option1: size,
          option2: null,
          option3: null,
          sku: sku || "",
          requires_shipping: true,
          taxable: false,
          featured_image: {
            id: variationId,
            product_id: groupId || productId,
            position: index + 1,
            src: image,
          },
          available: variant.inStock,
          name: `${name} - ${size}`,
          public_title: size,
          options: [size],
          price: price ? Math.round(price * 100) : 0,
          weight: 0,
          compare_at_price: comparePrice
            ? Math.round(comparePrice * 100)
            : null,
          inventory_management: "shopify",
          barcode: barcode || "",
          featured_media: {
            id: variationId,
            position: index + 1,
            preview_image: {
              src: image,
            },
          },
          requires_selling_plan: false,
          selling_plan_allocations: [],
          quantity_rule: {
            min: 1,
            max: null,
            increment: 1,
          },
        });
      });
    }
    else {
      const variationId = product.id;
    
      const sellingPrice = parseFloat(String(product.sellingPrice).replace(/,/g, ""));
      const comparePrice = parseFloat(String(product.price).replace(/,/g, ""));
      result.push({
        id: variationId,
        title: product.name,
        option1: product.name,
        option2: null,
        option3: null,
        sku: product.sku?.[0] || "",
        requires_shipping: true,
        taxable: false,
        featured_image: {
          id: variationId,
          product_id: groupId || productId,
          position: 1,
          src: mainImage,
        },
        available: product.inStock,
        name: product.name,
        public_title: product.name,
        options: [product.name],
        price: Math.round(price * 100),
        weight: 0,
        compare_at_price: Math.round(comparePrice * 100),
        inventory_management: "shopify",
        barcode: product.sku?.[0] || "",
        featured_media: {
          id: variationId,
          position: 1,
          preview_image: {
            src: mainImage,
          },
        },
        requires_selling_plan: false,
        selling_plan_allocations: [],
        quantity_rule: {
          min: 1,
          max: null,
          increment: 1,
        },
      });
    }
    return result;
  }

  function applyWizzyQuickBuyButtonState(
    productVariants,
    submitButton,
    submitButtonInner,
    variantSelect,
  ) {
    if (!productVariants || !submitButton || !submitButtonInner) {
      return;
    }

    var cv = productVariants.currentVariant;
    var variantRequired = !!productVariants.variantRequired;
    var placeholder =
      variantSelect &&
      variantSelect.options &&
      variantSelect.options.length > 0 &&
      variantSelect.selectedIndex === 0;

    if (
      !cv &&
      !variantRequired &&
      (!variantSelect || variantSelect.options.length <= 1)
    ) {
      var only =
        productVariants.getVariantData && productVariants.getVariantData();
      if (only && only.length === 1) {
        cv = only[0];
      }
    }

    var locales =
      typeof KROWN !== "undefined" && KROWN.settings && KROWN.settings.locales
        ? KROWN.settings.locales
        : null;

    if (variantRequired && placeholder) {
      submitButtonInner.innerText = "Select Size";
      submitButton.disabled = true;
      submitButton.setAttribute("disabled", "");
      submitButton.classList.add("disabled");
      return;
    }

    if (!cv || !cv.available) {
      submitButtonInner.innerText = locales
        ? locales.products_sold_out_variant
        : "Sold Out";
      submitButton.disabled = true;
      submitButton.setAttribute("disabled", "");
      submitButton.classList.add("disabled");
      return;
    }

    submitButtonInner.innerText = locales
      ? locales.products_add_to_cart_button
      : "Add to Cart";
    submitButton.disabled = false;
    submitButton.removeAttribute("disabled");
    submitButton.classList.remove("disabled");
  }

  function initWizzySearchResultQuickBuy(root = document) {
    root
      .querySelectorAll(".wizzy-result-product .product-item__quick-buy")
      .forEach(function (quickBuyElement) {
        if (quickBuyElement.hasAttribute("data-wizzy-qb-init")) {
          return;
        }
        quickBuyElement.setAttribute("data-wizzy-qb-init", "true");
        const variantSelect = quickBuyElement.querySelector(
          "select.product-variant__container",
        );
        const form = quickBuyElement.querySelector("form");
        const productVariants =
          quickBuyElement.querySelector("product-variants");
        const submitButton = form?.querySelector('button[type="submit"]');
        const submitButtonInner =
          submitButton?.querySelector("span.button__text");

        if (!form || !submitButton || !submitButtonInner) {
          return;
        }

        const enabledVariantCount = variantSelect
          ? Array.from(variantSelect.options).filter(function (opt) {
            return !opt.disabled;
          }).length
          : 0;

        if (variantSelect && enabledVariantCount > 1) {
          submitButton.classList.add("has_many_variant");

          form.addEventListener("submit", function () {
            setTimeout(() => {
              variantSelect.selectedIndex = 0;
              if (productVariants) {
                productVariants.noVariantSelectedYet = true;
              }
              variantSelect.dispatchEvent(new Event("change"));
              if (productVariants) {
                productVariants.style.zIndex = 100;
              }
            }, 500);
          });

          variantSelect.addEventListener("change", function () {
            if (
              productVariants &&
              typeof productVariants.onVariantChange === "function"
            ) {
              productVariants.onVariantChange();
            }
            applyWizzyQuickBuyButtonState(
              productVariants,
              submitButton,
              submitButtonInner,
              variantSelect,
            );
            if (variantSelect.selectedIndex !== 0 && productVariants) {
              productVariants.style.zIndex = 0;
            }
          });

          if (
            productVariants &&
            typeof productVariants.onVariantChange === "function"
          ) {
            productVariants.onVariantChange();
          }
          applyWizzyQuickBuyButtonState(
            productVariants,
            submitButton,
            submitButtonInner,
            variantSelect,
          );
        } else {
          if (variantSelect) {
            variantSelect.remove();
          }
          if (
            productVariants &&
            typeof productVariants.onVariantChange === "function"
          ) {
            productVariants.onVariantChange();
          }
          if (productVariants) {
            applyWizzyQuickBuyButtonState(
              productVariants,
              submitButton,
              submitButtonInner,
              null,
            );
            productVariants.style.zIndex = 0;
          } else {
            submitButtonInner.innerText = "Add to Cart";
            submitButton.disabled = false;
            submitButton.removeAttribute("disabled");
            submitButton.classList.remove("disabled");
          }
        }
      });
  }

  function stringifyVariantsForHtmlScript(variants) {
    return JSON.stringify(variants).replace(/</g, "\\u003c");
  }





  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function sanitizeUserQuery(q) {
    if (typeof q !== "string") return q;
    return q.replace(/[<>]/g, "");
  }

  // Allow only <em> for Wizzy match highlighting; escape everything else.
  function sanitizeHighlightHtml(str) {
    if (typeof str !== "string") return str;
    return escapeHtml(str)
      .replace(/&lt;(\/?em)&gt;/gi, "<$1>");
  }

  function sanitizeAutocompleteSuggestions(payload) {
    if (!payload) return payload;
    if (typeof payload.query === "string") {
      payload.query = sanitizeUserQuery(payload.query);
    }
    if (Array.isArray(payload.suggestions)) {
      payload.suggestions.forEach(function (item) {
        if (!item) return;
        // Non-head labels render via [[&label]] (for <em> highlights) — sanitize here.
        if (!item.isHead && typeof item.label === "string") {
          item.label = sanitizeHighlightHtml(item.label);
        }
        if (typeof item.searchTerm === "string") {
          item.searchTerm = sanitizeUserQuery(item.searchTerm);
        }
      });
    }
    return payload;
  }

  window.onWizzyScriptLoaded = function () {
    changeTemplate("wizzy-search-results-product");
    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
      function (payload) {
        window.wizzyConfig.search.configs.general.minQueryLength = 1;
        if (window.innerWidth < 768) {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#search_mini_form #searchInput",
            type: "search",
          };
        } else {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#site-header .st-search-box.hidden-mobile .st-search-input",
            type: "text",
          };
        }

        payload.search.configs.pagination.appendInExistingList = "true";
        payload.filters.configs.layout = "v1";
        window.wizzyConfig.common.isOnCategoryPage == true
          ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
          : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "body main",
          ]);
        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply =
          "true";
        window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible =
          "true";

        window.wizzyConfig.search.configs.facets.showPriceInputRangeFields =
          "true";

        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
      function (payload) {
        window.wizzyConfig.search.configs.general.minQueryLength = 1;

        if (window.innerWidth < 768) {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#search_mini_form",
            type: "search",
          };
        } else {
          window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
            dom: "#site-header .st-search-box.hidden-mobile .st-search-input",
            type: "text",
          };
        }

        payload.search.configs.pagination.appendInExistingList = "true";
        payload.filters.configs.layout = "v1";
        window.wizzyConfig.common.isOnCategoryPage == true
          ? (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "#wizzy-shopify-collection-page-wrapper",
          ])
          : (window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers = [
            "body main",
          ]);

        window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply =
          "true";
        window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible =
          "true";

        window.wizzyConfig.search.configs.facets.showPriceInputRangeFields =
          "true";

        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        payload.minQueryLength = 1;
        if (typeof payload.q === "string") {
          payload.q = sanitizeUserQuery(payload.q);
        }
        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
      function (payload) {
        return sanitizeAutocompleteSuggestions(payload);
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
      function (payload) {
        if (payload && typeof payload.query === "string") {
          payload.query = sanitizeUserQuery(payload.query);
        }
        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
      function (payload) {
        window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers[0] =
          "body main";
        payload.attributeFacetValuesLimit = 100;
        payload.minQueryLength = 1;

        const closeBtn =
          window.innerWidth < 768
            ? document.querySelector(".wizzy-search-form .wizzy-search-back")
            : document.querySelector(
              "main-header .header-container.header-container--bottom .st-search-close-btn",
            );
        if (closeBtn) {
          closeBtn.click();
        }

        if (typeof payload.q === "string") {
          const clean = sanitizeUserQuery(payload.q);
          if (clean !== payload.q) {
            payload.q = clean;
            try {
              const url = new URL(window.location.href);
              if (url.searchParams.has("q")) {
                url.searchParams.set("q", clean);
                history.replaceState(history.state, document.title, url.toString());
              }
            } catch (e) {}
            document.querySelectorAll('input[name="q"], .st-search-input, #searchInput').forEach(function (input) {
              if (input && /[<>]/.test(input.value || "")) {
                input.value = clean;
              }
            });
          }
        }

        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
      function (payload) {
        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
      function (products) {
        if (products) {
          try {
            products.forEach((product) => {
              product.dynamicText = false;
              product.sliderImages = false;
              product.hasMultipleVariations = false;
              
              if (typeof product.name === "string" && /[<>]/.test(product.name)) {
                product.name = escapeHtml(product.name);
              }
              if (typeof product.subTitle === "string" && /[<>]/.test(product.subTitle)) {
                product.subTitle = escapeHtml(product.subTitle);
              }
              if(typeof product.price != "undefined" && product.price && product.price.toString().includes(".")) {
                product.price = product.price.toString().split(".")[0];
              }

              if(typeof product.sellingPrice != "undefined" && product.sellingPrice && product.sellingPrice.toString().includes(".")) {
                product.sellingPrice = product.sellingPrice.toString().split(".")[0];
              }
              
              if (product.attributes) {
                product.attributes.forEach((attr) => {
                  if (attr.id === "product_product_dynamic_text_custom") {
                    product.dynamicText = attr.values[0].value[0];
                  } else if (attr.id === "product_handle") {
                    product.handle = attr.values[0].value[0];
                  } else if (attr.id === "product_reviews_average_yotpo") {
                    product.rating = generateStars(attr.values[0].value[0]);
                  } else if (attr.id === "product_variant_prices") {
                    if (attr.values.length > 1) {
                      product.hasMultipleVariations = true;
                    }
                  }
                });
              }
            });
          } catch (error) {
            console.log(error);
          }
        }
        return products;
      },
    );
    
    function setDefaultGridFilterPostitions() {
      window.wizzyConfig.gridFilters.filters = window.wizzyConfig?.gridFilters?.filters?.map((item, index) => ({
        ...item,
        after: {
          web: (index + 2) * 3,
          mobile: (index + 2) * 3
        }
      }));
    }

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
      function (payload) {
        try {
          if (
            (payload.data.api === "search" || payload.data.api === "filter") &&
            payload.data.response.payload.total !== 0
          ) {
            if (window.innerWidth < 768) {
              handleScrollOnSearchPage();
            } else {
              const wizzySortWrapper = document.querySelector(
                ".wizzy-search-sort-wrapper",
              );
              const wizzySortFilterWrapper = document.querySelector(
                ".wizzy-sort-filter-wrapper",
              );
              if (
                wizzySortWrapper &&
                wizzySortFilterWrapper &&
                !wizzySortFilterWrapper.contains(wizzySortWrapper)
              ) {
                wizzySortFilterWrapper.appendChild(wizzySortWrapper);
              }
            }
            /*view more button - starts here*/
            payload.data.response.payload.facets.forEach((facet) => {
              if (facet.data.length > 5) {
                const element = document.querySelector(
                  '[data-key="' + facet.key + '"]',
                );
                const facetItems = element.querySelectorAll(
                  ".wizzy-facet-body .wizzy-facet-list li",
                );
                const viewMoreBtn = element.querySelector(
                  ".wizzy-view-more-btn",
                );
                createViewMoreBtn(5, element, facetItems, viewMoreBtn);
              }
            });
            /*view more button - ends here*/

            /* Add variantion JSON to each product - starts here*/
            const products = payload?.data?.response?.payload?.result;
            injectVariantScripts(products);
            initWizzySearchResultQuickBuy(document);

            /* Add variantion JSON to each product - ends here*/
          }

          if (
            payload.data.api === "autocomplete" ||
            (payload.data.api === "filter" &&
              payload.data.response.payload.filters.type ===
              "AUTOCOMPLETE_DEFAULT")
          ) {
            if (typeof window.syncDesktopAutocompleteDisplay === "function") {
              requestAnimationFrame(window.syncDesktopAutocompleteDisplay);
            }
          }
        } catch (error) {
          console.log(error);
        }

        if (window.wizzyConfig.common.isOnCategoryPage) {
        }

        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
      function (payload) {
        console.log("BEFORE_RENDER_RESULTS--->>>",payload);
        if(payload.response.payload.banners === "undefined" || !payload?.response?.payload?.banners?.some(b => b.displayAs === 'banner')) {
          setDefaultGridFilterPostitions();
        }
        try {
          const products = payload?.data?.response?.payload?.result;
          if (products && products.length) {
            products.forEach(function (product) {
              const transformed =
                product.transformedVariants || transformToVariants(product);
              product.transformedVariants = transformed;
              product.variantsJson =
                stringifyVariantsForHtmlScript(transformed);
            });
          }
        } catch (e) {
          console.log(e);
        }

        return payload;
      },
    );

    window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
      function (payload) {
        try {
          const products = payload?.data?.response?.payload?.result;
          if (products && products.length) {
            injectVariantScripts(products);
          }
        } catch (e) {
          console.log(e);
        }
        initWizzySearchResultQuickBuy(document);
        return payload;
      },
    );
  };
} catch (e) {
  console.log(e);
}

function injectVariantScripts(products) {
  if (!products || !products.length) return;

  const productVariantEls = document.querySelectorAll(
    ".wizzy-result-product product-variants",
  );

  productVariantEls.forEach((el, index) => {
    const product = products[index];
    if (!product) return;

    const variants = transformToVariants(product);
    const jsonText = stringifyVariantsForHtmlScript(variants);

    let script = el.querySelector('script[type="application/json"]');
    if (!script) {
      script = document.createElement("script");
      script.type = "application/json";
      el.appendChild(script);
    }
    script.textContent = jsonText;
    el.appendChild(script);

    el.variantData = undefined;
    const select = el.querySelector(
      'select[data-js-product-variant-container="select"]',
    );
    if (select) {
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }
  });
}
